module.exports = "/wp-content/plugins/farmacy/assets/js/fonts/glyphicons-halflings-regular-448c34a56d699c29117adc64c43affeb.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/scss/fonts/bootstrap/glyphicons-halflings-regular.woff2
 ** module id = 229
 ** module chunks = 1 2 6 7 12 23 42 48 62
 **/